export default "__VITE_ASSET__B700iYXJ__"